var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',[_c('i',{staticClass:"el-icon-caret-top",staticStyle:{"font-size":"40px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }